<template>
  <div
    v-if="columns == 1"
    class="row content-block"
    :style="`background-color:` + this.background + `;`"
  >
    <editor-content
      :editor="editorOneColumn"
      :class="columnContentClasses.value"
    />
  </div>
  <div
    v-else-if="columns == 2"
    class="row content-block"
    :style="`background-color:` + this.background + `;`"
  >
    <editor-content
      :editor="editorColumnsFirst"
      :class="columnsFirstContentClasses.value"
    />
    <editor-content
      :editor="editorColumnsSecond"
      :class="columnsSecondContentClasses.value"
    />
  </div>
  <div
    v-else-if="columns == 3"
    class="row content-block"
    :style="`background-color:` + this.background + `;`"
  >
    <editor-content
      :editor="editorColumnsFirst"
      :class="columnsFirstContentClasses.value"
    />
    <editor-content
      :editor="editorColumnsSecond"
      :class="columnsSecondContentClasses.value"
    />
    <editor-content
      :editor="editorColumnsThird"
      :class="columnsThirdContentClasses.value"
    />
  </div>
  <div
    v-else-if="columns == 4"
    class="row content-block"
    :style="`background-color:` + this.background + `;`"
  >
    <editor-content
      :editor="editorColumnsFirst"
      :class="columnsFirstContentClasses.value"
    />
    <editor-content
      :editor="editorColumnsSecond"
      :class="columnsSecondContentClasses.value"
    />
    <editor-content
      :editor="editorColumnsThird"
      :class="columnsThirdContentClasses.value"
    />
    <editor-content
      :editor="editorColumnsFourth"
      :class="columnsFourthContentClasses.value"
    />
  </div>
</template>
<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import Underline from '@tiptap/extension-underline'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import ListItem from '@tiptap/extension-list-item'
import Heading from '@tiptap/extension-heading'
//import Span from './tiptap-span'
//import { Mark } from '@tiptap/core'
import FontSize from './editor_extensions/font-size.js'
//import Div from './editor_extensions/div.js'
import { mergeAttributes } from '@tiptap/core'
import Strike from '@tiptap/extension-strike'
import Focus from '@tiptap/extension-focus'
import HardBreak from '@tiptap/extension-hard-break'
//import CustomFocus from './editor_extensions/custom-focus.js'
//import Image from '@tiptap/extension-image'
import History from '@tiptap/extension-history'
import CustomImage from './editor_extensions/custom-image.js'
import CustomImageBanner from './editor_extensions/custom-image-banner.js'
//import Link from '@tiptap/extension-link'
import CustomLink from './editor_extensions/custom-link.js'

import { findParentNode, findChildren, defaultBlockAt} from '@tiptap/core';
import { Selection } from 'prosemirror-state';

import Details from '@tiptap/extension-details'
import DetailsSummary from '@tiptap/extension-details-summary'
import DetailsContent from '@tiptap/extension-details-content'
import Placeholder from '@tiptap/extension-placeholder'

//import CustomAudio from './editor_extensions/custom-audio.js'

import i18n from '../plugins/i18n.js'

import Audio from './editor_extensions/audio-vuetify.js'
import Emoji from '@tiptap/extension-emoji'
import suggestion from './suggestion'
import Iframe from './editor_extensions/iframe.js'

import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import Gapcursor from '@tiptap/extension-gapcursor'

export default {
    components: {
        EditorContent
    },
    props:{
        content: {
          type: String,
          default: ''
        },
        index: {
          type: Number,
          default: 0
        },
        background: {
          type: String,
          default: '#FFFFFF'
        }
    },
    data(){
      return{
        editorOneColumn: null,
        editorColumnsFirst: null,
        editorColumnsSecond: null,
        editorColumnsThird: null,
        editorColumnsFourth: null,
        columns: 1,
        columnContentClasses: '',
        columnsFirstContent: '',
        columnsFirstContentClasses: '',
        columnsSecondContentClasses: '',
        columnsSecondContent: '',
        columnsThirdContentClasses: '',
        columnsThirdContent: '',
        columnsFourthContentClasses: '',
        columnsFourthContent: '',
        oldContent: this.content
      }
    },
    created(){
      this.columns = this.content.split('<column-separator></column-separator>').length
      /*eslint-disable*/
      if(this.columns == 2){
        var elementcolumnsFirstContent = document.createElement('div');
        var elementcolumnsSecondContent = document.createElement('div');
        elementcolumnsFirstContent.insertAdjacentHTML('beforeend', this.content.split('<column-separator></column-separator>')[0]);
        elementcolumnsSecondContent.insertAdjacentHTML('beforeend', this.content.split('<column-separator></column-separator>')[1]);
        this.columnsFirstContentClasses = elementcolumnsFirstContent.querySelector('[class*="column"]').classList;
        this.columnsSecondContentClasses = elementcolumnsSecondContent.querySelector('[class*="column"]').classList;
        this.columnsFirstContent = elementcolumnsFirstContent.querySelector('[class*="column"]').innerHTML;
        this.columnsSecondContent = elementcolumnsSecondContent.querySelector('[class*="column"]').innerHTML;
      }
      else if(this.columns == 3){
        var elementcolumnsFirstContent = document.createElement('div');
        var elementcolumnsSecondContent = document.createElement('div');
        var elementcolumnsThirdContent = document.createElement('div');
        elementcolumnsFirstContent.insertAdjacentHTML('beforeend', this.content.split('<column-separator></column-separator>')[0]);
        elementcolumnsSecondContent.insertAdjacentHTML('beforeend', this.content.split('<column-separator></column-separator>')[1]);
        elementcolumnsThirdContent.insertAdjacentHTML('beforeend', this.content.split('<column-separator></column-separator>')[2]);
        this.columnsFirstContentClasses = elementcolumnsFirstContent.querySelector('[class*="column"]').classList;
        this.columnsSecondContentClasses = elementcolumnsSecondContent.querySelector('[class*="column"]').classList;
        this.columnsThirdContentClasses = elementcolumnsThirdContent.querySelector('[class*="column"]').classList;
        this.columnsFirstContent = elementcolumnsFirstContent.querySelector('[class*="column"]').innerHTML;
        this.columnsSecondContent = elementcolumnsSecondContent.querySelector('[class*="column"]').innerHTML;
        this.columnsThirdContent = elementcolumnsThirdContent.querySelector('[class*="column"]').innerHTML;
      }
      else if(this.columns == 4){
        var elementcolumnsFirstContent = document.createElement('div');
        var elementcolumnsSecondContent = document.createElement('div');
        var elementcolumnsThirdContent = document.createElement('div');
        var elementcolumnsFourthContent = document.createElement('div');
        elementcolumnsFirstContent.insertAdjacentHTML('beforeend', this.content.split('<column-separator></column-separator>')[0]);
        elementcolumnsSecondContent.insertAdjacentHTML('beforeend', this.content.split('<column-separator></column-separator>')[1]);
        elementcolumnsThirdContent.insertAdjacentHTML('beforeend', this.content.split('<column-separator></column-separator>')[2]);
        elementcolumnsFourthContent.insertAdjacentHTML('beforeend', this.content.split('<column-separator></column-separator>')[3]);
        this.columnsFirstContentClasses = elementcolumnsFirstContent.querySelector('[class*="column"]').classList;
        this.columnsSecondContentClasses = elementcolumnsSecondContent.querySelector('[class*="column"]').classList;
        this.columnsThirdContentClasses = elementcolumnsThirdContent.querySelector('[class*="column"]').classList;
        this.columnsFourthContentClasses = elementcolumnsFourthContent.querySelector('[class*="column"]').classList;
        this.columnsFirstContent = elementcolumnsFirstContent.querySelector('[class*="column"]').innerHTML;
        this.columnsSecondContent = elementcolumnsSecondContent.querySelector('[class*="column"]').innerHTML;
        this.columnsThirdContent = elementcolumnsThirdContent.querySelector('[class*="column"]').innerHTML;
        this.columnsFourthContent = elementcolumnsFourthContent.querySelector('[class*="column"]').innerHTML;
      }else {
        var elementcolumnContent = document.createElement('div');
        elementcolumnContent.insertAdjacentHTML('beforeend', this.content);
        this.columnContentClasses = elementcolumnContent.querySelector('[class*="column"]').classList;
      }
    },
    mounted() {
      //override paragraph node - was not working in separate file
      const CustomParagraph = Paragraph.extend({
        addAttributes() {
          return {
            class: {
                default: '',
                rendered: true
            }
          }
        },
        addCommands() {
          return {
            setParagraph: attributes => ({ commands }) => {
              return commands.setNode('paragraph', attributes);
            },
          }
        }
      })

      const CustomTextStyle = TextStyle.extend({
        addAttributes() {
          return {
            class: {
                default: '',
                rendered: true
            }
          }
        },
      })    

      //issues when override detailsContent node in separate file
      const isNodeVisible = (position, editor) => {
        const node = editor.view.domAtPos(position).node;
        const isOpen = node.offsetParent !== null;
        return isOpen;
      };
      const CustomDetails = Details.extend({
        addCommands() {
            return {
                setDetails: () => ({ state, chain }) => {
                    var _a;
                    const { schema, selection } = state;
                    const { $from, $to } = selection;
                    const range = $from.blockRange($to);
                    if (!range) {
                        return false;
                    }
                    const slice = state.doc.slice(range.start, range.end);
                    const match = schema.nodes.detailsContent.contentMatch.matchFragment(slice.content);
                    if (!match) {
                        return false;
                    }
                    const content = ((_a = slice.toJSON()) === null || _a === void 0 ? void 0 : _a.content) || [];
  
                    return chain()
                        .insertContentAt({ from: range.start, to: range.end }, {
                        type: this.name,
                        content: [
                            {
                                type: 'detailsSummary'
                              
                            },
                            {
                                type: 'detailsContent',
                                content,
                            },
                        ],
                    })
                        .setTextSelection(range.start + 2)
                        .setBold()
                        .run();
                },
                unsetDetails: () => ({ state, chain }) => {
                    const { selection, schema } = state;
                    const details = findParentNode(node => node.type === this.type)(selection);
                    if (!details) {
                        return false;
                    }
                    const detailsSummaries = findChildren(details.node, node => node.type === schema.nodes.detailsSummary);
                    const detailsContents = findChildren(details.node, node => node.type === schema.nodes.detailsContent);
                    if (!detailsSummaries.length || !detailsContents.length) {
                        return false;
                    }
                    const detailsSummary = detailsSummaries[0];
                    const detailsContent = detailsContents[0];
                    const from = details.pos;
                    const $from = state.doc.resolve(from);
                    const to = from + details.node.nodeSize;
                    const range = { from, to };
                    const content = detailsContent.node.content.toJSON() || [];
                    const defaultTypeForSummary = $from.parent.type.contentMatch.defaultType;
                    // TODO: this may break for some custom schemas
                    const summaryContent = defaultTypeForSummary === null || defaultTypeForSummary === void 0 ? void 0 : defaultTypeForSummary.create(null, detailsSummary.node.content).toJSON();
                    const mergedContent = [
                        summaryContent,
                        ...content,
                    ];
                    return chain()
                        .insertContentAt(range, mergedContent)
                        .setTextSelection(from + 1)
                        .run();
                },
            };
        },
        addKeyboardShortcuts() {
        return {
          Backspace: () => {
            const { schema, selection } = this.editor.state;
            const { empty, $anchor } = selection;
            if (!empty || $anchor.parent.type !== schema.nodes.detailsSummary) {
                return false;
            }
            // for some reason safari removes the whole text content within a `<summary>`tag on backspace
            // so we have to remove the text manually
            // see: https://discuss.prosemirror.net/t/safari-backspace-bug-with-details-tag/4223
            if ($anchor.parentOffset !== 0) {
                return this.editor.commands.command(({ tr }) => {
                    const from = $anchor.pos - 1;
                    const to = $anchor.pos;
                    tr.delete(from, to);
                    return true;
                });
            }
            this.editor.commands.unsetDetails();
            this.editor.commands.deleteNode('paragraph')

          },
          Enter: ({ editor }) => {
            const { state, view } = editor;
            const { schema, selection } = state;
            const { $head } = selection;
            if ($head.parent.type !== schema.nodes.detailsSummary) {
                return false;
            }
            const isVisible = isNodeVisible($head.after() + 1, editor);
            const above = isVisible
                ? state.doc.nodeAt($head.after())
                : $head.node(-2);
            if (!above) {
                return false;
            }
            const after = isVisible
                ? 0
                : $head.indexAfter(-1);
            const type = defaultBlockAt(above.contentMatchAt(after));
            if (!type || !above.canReplaceWith(after, after, type)) {
                return false;
            }
            const node = type.createAndFill();
            if (!node) {
                return false;
            }

            const pos = isVisible
                ? $head.after() + 1
                : $head.after(-1);
            const tr = state.tr.replaceWith(pos, pos, node);
            const $pos = tr.doc.resolve(pos);
            const newSelection = Selection.near($pos, 1);
            tr.setSelection(newSelection);
            tr.scrollIntoView();
            view.dispatch(tr);
            this.editor.schema.nodes.details.defaultAttrs.open = true
            isVisible ? '' : this.editor.commands.setDetails()
            return true;
            }
          }
        },
      })
      const CustomDetailsContent = DetailsContent.extend({
        addKeyboardShortcuts() {
        return {
            // Escape node on double enter
            Enter: ({ editor }) => {
                const { state, view } = editor;
                const { selection } = state;
                const { $from, empty } = selection;
                const detailsContent = findParentNode(node => node.type === this.type)(selection);
                if (!empty || !detailsContent || !detailsContent.node.childCount) {
                    return false;
                }
                const fromIndex = $from.index(detailsContent.depth);
                const { childCount } = detailsContent.node;
                const isAtEnd = childCount === fromIndex + 1;
                if (!isAtEnd) {
                    return false;
                }
                const defaultChildType = detailsContent.node.type.contentMatch.defaultType;
                const defaultChildNode = defaultChildType === null || defaultChildType === void 0 ? void 0 : defaultChildType.createAndFill();
                if (!defaultChildNode) {
                    return false;
                }
                const $childPos = state.doc.resolve(detailsContent.pos + 1);
                const lastChildIndex = childCount - 1;
                const lastChildNode = detailsContent.node.child(lastChildIndex);
                const lastChildPos = $childPos.posAtIndex(lastChildIndex, detailsContent.depth);
                const lastChildNodeIsEmpty = lastChildNode.eq(defaultChildNode);
                if (!lastChildNodeIsEmpty) {
                    return false;
                }
                // get parent of details node
                const above = $from.node(-3);
                if (!above) {
                    return false;
                }
                // get default node type after details node
                const after = $from.indexAfter(-3);
                const type = defaultBlockAt(above.contentMatchAt(after));
                if (!type || !above.canReplaceWith(after, after, type)) {
                    return false;
                }
                const node = type.createAndFill();
                if (!node) {
                    return false;
                }

                const { tr } = state;
                const pos = $from.after(-2);
                tr.replaceWith(pos, pos, node);
                const $pos = tr.doc.resolve(pos);
                const newSelection = Selection.near($pos, 1);
                tr.setSelection(newSelection);
                const deleteFrom = lastChildPos;
                const deleteTo = lastChildPos + lastChildNode.nodeSize;
                tr.delete(deleteFrom, deleteTo);
                tr.scrollIntoView();
                view.dispatch(tr);
                this.editor.schema.nodes.details.defaultAttrs.open = true
                this.editor.commands.setDetails()
                return true;
            },
        };
    },
})
const CustomTableHeader = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent(),
      colwidth: {
        default: null,
        parseHTML: element => {
          const colwidth = element.getAttribute('colwidth');
          const value = colwidth
            ? colwidth.split(',').map(item => parseInt(item, 10))
            : null;

          return value;
        },
      },
      style: {
        default: null,
      },
    };
  },
  renderHTML({ HTMLAttributes }) {
    let totalWidth = 0;
    let fixedWidth = true;

    if (HTMLAttributes.colwidth) {
      HTMLAttributes.colwidth.forEach(col => {
        if (!col) {
          fixedWidth = false;
        } else {
          totalWidth += col;
        }
      });
    } else {
      fixedWidth = false;
    }

    if (fixedWidth && totalWidth > 0) {
      HTMLAttributes.style = `width: ${totalWidth}px;`;
    } else if (totalWidth && totalWidth > 0) {
      HTMLAttributes.style = `min-width: ${totalWidth}px`;
    } else {
      HTMLAttributes.style = null;
    }

    return [
      'th',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },
})
const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent(),
      colwidth: {
        default: null,
        parseHTML: element => {
          const colwidth = element.getAttribute('colwidth');
          const value = colwidth
            ? colwidth.split(',').map(item => parseInt(item, 10))
            : null;

          return value;
        },
      },
      style: {
        default: null,
      },
    };
  },
  renderHTML({ HTMLAttributes }) {
    let totalWidth = 0;
    let fixedWidth = true;

    if (HTMLAttributes.colwidth) {
      HTMLAttributes.colwidth.forEach(col => {
        if (!col) {
          fixedWidth = false;
        } else {
          totalWidth += col;
        }
      });
    } else {
      fixedWidth = false;
    }

    if (fixedWidth && totalWidth > 0) {
      HTMLAttributes.style = `width: ${totalWidth}px;`;
    } else if (totalWidth && totalWidth > 0) {
      HTMLAttributes.style = `min-width: ${totalWidth}px`;
    } else {
      HTMLAttributes.style = null;
    }

    return [
      'td',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },
})
const CustomTable = Table.extend({
    addAttributes() {
        return {
            style: {
                default: null,
                rendered: true
            },
        };
    },
    renderHTML({ node, HTMLAttributes }) {
    let totalWidth = 0;
    let fixedWidth = true;

    try {
      // use first row to determine width of table;
      const tr = node.content.content[0];
      tr.content.content.forEach(td => {
        if (td.attrs.colwidth) {
          td.attrs.colwidth.forEach(col => {
            if (!col) {
              fixedWidth = false;
              totalWidth += this.options.cellMinWidth;
            } else {
              totalWidth += col;
            }
          });
        } else {
          fixedWidth = false;
          const colspan = td.attrs.colspan ? td.attrs.colspan : 1;
          totalWidth += this.options.cellMinWidth * colspan;
        }
      });
    } catch (error) {
      fixedWidth = false;
    }

    if (fixedWidth && totalWidth > 0) {
      HTMLAttributes.style = `width: ${totalWidth}px;`;
    } else if (totalWidth && totalWidth > 0) {
      HTMLAttributes.style = `min-width: ${totalWidth}px`;
    } else {
      HTMLAttributes.style = null;
    }

    return ['div', { class: 'tableWrapper' }, ['table', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), ['tbody', 0]]];
  },
});

      

    
    this.editorOneColumn = new Editor({
      editorProps: {
        handleClick: ( ) => {
          this.setActiveEditor(this.editorOneColumn)
        },
        handleDoubleClick: ( ) => {
            this.editorOneColumn.setEditable(true)
            this.$emit('enableEditMode')
        },
        handleDOMEvents: {
            drop: (view, e) => { e.preventDefault(); },
            paste: (view, e) => {
                if(this.editorOneColumn.isActive('custom-image-banner') || this.editorOneColumn.isActive('iframe')){
                    e.preventDefault();
                }
            },
            keydown: (view, e) => {
                /*if ((e.key === "Delete" || e.key === "Enter" || e.key == "Backspace") && (this.editorOneColumn.isActive('custom-image-banner') || this.editorOneColumn.isActive('iframe'))) {
                    e.preventDefault();
                }*/
                if(e.key && (this.editorOneColumn.isActive('custom-image-banner') || this.editorOneColumn.isActive('iframe'))){
                    e.preventDefault();
                }
                return false;
            }
        },
        transformPastedHTML: (html) => {
            return html.replace(/<img .*?>/g,'').replace(/<iframe .*?>/g,''); 
        }
      },
      // hide the drop position indicator
      dropCursor: { width: 0, color: 'transparent' },
      extensions: [
        Document,
        Text,
        Bold,
        Italic,
        Underline,
        Strike,
        Highlight,
        CustomLink.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
          },
        }),
        BulletList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        OrderedList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        ListItem,
        Heading.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        CustomParagraph.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        CustomTextStyle,
        Color,
        FontSize,
        Focus.configure({
          className: 'has-focus',
          mode: 'deepest'
        }),
        History,
        HardBreak,
        /*Image.configure({
          inline: true,
        })*/
        /*CustomImage.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        })*/
        CustomImageBanner.configure({
          HTMLAttributes: {
            class: 'd-flex add-transparent-border',
          },
          //draggable: false
        }),
        Iframe,
        //ExternalVideo,
        CustomDetails.configure({
          persist: true,
          HTMLAttributes: {
            class: 'details-accordion',
          },
        }),
        DetailsSummary.configure({
          HTMLAttributes: {
            class: 'summary-accordion add-transparent-border',
          },
        }),
        CustomDetailsContent.configure({
          HTMLAttributes: {
            class: 'content-accordion add-transparent-border',
          },
        }),
        Placeholder.configure({
          includeChildren: true,
          showOnlyWhenEditable: false,
          showOnlyCurrent: false,
          placeholder: ({ node }) => {                        
            if (node.type.name === 'detailsSummary') {
              return i18n.t('accordionTitlePlaceholder')
            }
            return null
          },
        }),
        Audio,
        Emoji.configure({
          enableEmoticons: true,
          suggestion,
          HTMLAttributes: {
            class: 'emoji',
          },
        }),
        CustomTable.configure({
          resizable: true,
          HTMLAttributes: {
            class: 'editor-table',
          }
        }),
        TableRow,
        CustomTableHeader,
        CustomTableCell,
        Gapcursor
        //CustomAudio
        //Div
      ],
      content: this.content,
      onUpdate: ({ editor }) => {
        //var newContent = '<div class="row content-block"><div class="'+ this.columnContentClasses.value +'">'+editor.getHTML()+'</div></div>'
        var newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnContentClasses.value +'">'+editor.getHTML()+'</div></div>'
        this.$emit('updateContent',this.index, newContent)
      },
      onSelectionUpdate: ({ editor}) => {
        /*const { view, state } = editor
        const { from, to } = view.state.selection
        const text = state.doc.textBetween(from, to, '')*/
        this.$emit('proceedClick',editor)
        const { view: { state: { tr: { selection } } } } = editor
        this.$emit('proceedMark', !selection.empty)
      },
    }),

    this.editorColumnsFirst = new Editor({
      editorProps: {
        handleClick: () => {
          this.setActiveEditor(this.editorColumnsFirst)
        },
        handleDoubleClick: ( ) => {
            this.editorColumnsFirst.setEditable(true)
            this.$emit('enableEditMode')
        },
        handleDOMEvents: {
            drop: (view, e) => { e.preventDefault(); },
            paste: (view, e) => {
                /*if(e.target.nodeName == 'IMG'){
                    e.preventDefault();
                }*/
                if(this.editorColumnsFirst.isActive('custom-image') || this.editorColumnsFirst.isActive('iframe')){
                    e.preventDefault();
                }
            },
            keydown: (view, e) => {
                /*if ((e.key === "Delete" || e.key === "Enter" || e.key == "Backspace") && (this.editorColumnsFirst.isActive('custom-image') || this.editorColumnsFirst.isActive('iframe'))) {
                    e.preventDefault();
                }*/
                if(e.key && (this.editorColumnsFirst.isActive('custom-image') || this.editorColumnsFirst.isActive('iframe'))){
                    e.preventDefault();
                }
                return false;
            }
        },
        transformPastedHTML: (html) => {
            return html.replace(/<img .*?>/g,'').replace(/<iframe .*?>/g,''); 
        }
      },
      // hide the drop position indicator
      dropCursor: { width: 0, color: 'transparent' },
      extensions: [
        Document,
        Text,
        Bold,
        Italic,
        Underline,
        Strike,
        Highlight,
        CustomLink.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
          },
        }),
        BulletList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        OrderedList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        ListItem,
        Heading.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        CustomParagraph.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        CustomTextStyle,
        Color,
        FontSize,
        Focus.configure({
          className: 'has-focus',
          mode: 'deepest',
        }),
        History,
        HardBreak,
        /*Image.configure({
          inline: false,
        })*/
        CustomImage.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
          //draggable: false
        }),
        Iframe,
        //ExternalVideo,
        CustomDetails.configure({
          persist: true,
          HTMLAttributes: {
            class: 'details-accordion',
          },
        }),
        DetailsSummary.configure({
          HTMLAttributes: {
            class: 'summary-accordion add-transparent-border',
          },
        }),
        CustomDetailsContent.configure({
          HTMLAttributes: {
            class: 'content-accordion add-transparent-border',
          },
        }),
        Placeholder.configure({
          includeChildren: true,
          showOnlyWhenEditable: false,
          placeholder: ({ node }) => {
            if (node.type.name === 'detailsSummary') {
              return i18n.t('accordionTitlePlaceholder')
            }
            return null
          },
        }),
        Emoji.configure({
          enableEmoticons: true,
          suggestion,
          HTMLAttributes: {
            class: 'emoji',
          },
        }),
        CustomTable.configure({
          resizable: true,
          HTMLAttributes: {
            class: 'editor-table',
          }
        }),
        TableRow,
        CustomTableHeader,
        CustomTableCell,
        Gapcursor
        //Div
      ],
      content: this.columnsFirstContent,
      onUpdate: ({ editor}) => {
        this.columnsFirstContent = editor.getHTML()
        var newContent = ''
        if(this.columns == 2){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div></div>'
        }
        if(this.columns == 3){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div><column-separator></column-separator><div class="'+ this.columnsThirdContentClasses.value +'">'+this.columnsThirdContent+'</div></div>'
        }
        if(this.columns == 4){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div><column-separator></column-separator><div class="'+ this.columnsThirdContentClasses.value +'">'+this.columnsThirdContent+'</div><column-separator></column-separator><div class="'+ this.columnsFourthContentClasses.value +'">'+this.columnsFourthContent+'</div></div>'
        }
        this.$emit('updateContent',this.index, newContent)
      },
      onSelectionUpdate: ({ editor}) => {
        /*const { view, state } = editor
        const { from, to } = view.state.selection
        const text = state.doc.textBetween(from, to, '')*/
        this.$emit('proceedClick',editor)
        const { view: { state: { tr: { selection } } } } = editor
        this.$emit('proceedMark', !selection.empty)
      },
    })

    this.editorColumnsSecond = new Editor({
      editorProps: {
        handleClick: () => {
          this.setActiveEditor(this.editorColumnsSecond)
        },
        handleDoubleClick: ( ) => {
            this.editorColumnsSecond.setEditable(true)
            this.$emit('enableEditMode')
        },
        handleDOMEvents: {
            drop: (view, e) => { e.preventDefault(); },
            paste: (view, e) => {
                if(this.editorColumnsSecond.isActive('custom-image') || this.editorColumnsSecond.isActive('iframe')){
                    e.preventDefault();
                }
            },
            keydown: (view, e) => {
                /*if ((e.key === "Delete" || e.key === "Enter" || e.key == "Backspace") && (this.editorColumnsSecond.isActive('custom-image') || this.editorColumnsSecond.isActive('iframe'))) {
                    e.preventDefault();
                }*/
                if(e.key && (this.editorColumnsSecond.isActive('custom-image') || this.editorColumnsSecond.isActive('iframe'))) {
                    e.preventDefault();
                }
                return false;
            }
        },
        transformPastedHTML: (html) => {
            return html.replace(/<img .*?>/g,'').replace(/<iframe .*?>/g,''); 
        }
      },
      // hide the drop position indicator
      dropCursor: { width: 0, color: 'transparent' },
      extensions: [
        Document,
        Text,
        Bold,
        Italic,
        Underline,
        Strike,
        Highlight,
        CustomLink.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
          },
        }),
        BulletList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        OrderedList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        ListItem,
        Heading.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        CustomParagraph.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        CustomTextStyle,
        Color,
        FontSize,
        Focus.configure({
          className: 'has-focus',
          mode: 'deepest',
        }),
        History,
        HardBreak,
        /*Image.configure({
          inline: false,
        })*/
        CustomImage.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
          //draggable: false
        }),
        Iframe,
        //ExternalVideo,
        CustomDetails.configure({
          persist: true,
          HTMLAttributes: {
            class: 'details-accordion',
          },
        }),
        DetailsSummary.configure({
          HTMLAttributes: {
            class: 'summary-accordion add-transparent-border',
          },
        }),
        CustomDetailsContent.configure({
          HTMLAttributes: {
            class: 'content-accordion add-transparent-border',
          },
        }),
        Placeholder.configure({
          includeChildren: true,
          showOnlyWhenEditable: false,
          placeholder: ({ node }) => {
            if (node.type.name === 'detailsSummary') {
              return i18n.t('accordionTitlePlaceholder')
            }
            return null
          },
        }),
        Emoji.configure({
          enableEmoticons: true,
          suggestion,
          HTMLAttributes: {
            class: 'emoji',
          },
        }),
        CustomTable.configure({
          resizable: true,
          HTMLAttributes: {
            class: 'editor-table',
          }
        }),
        TableRow,
        CustomTableHeader,
        CustomTableCell,
        Gapcursor
        //Div
      ],
      content: this.columnsSecondContent,
      onUpdate: ({ editor}) => {
        this.columnsSecondContent = editor.getHTML()
        var newContent = ''
        if(this.columns == 2){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div></div>'
        }
        if(this.columns == 3){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div><column-separator></column-separator><div class="'+ this.columnsThirdContentClasses.value +'">'+this.columnsThirdContent+'</div></div>'
        }
        if(this.columns == 4){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div><column-separator></column-separator><div class="'+ this.columnsThirdContentClasses.value +'">'+this.columnsThirdContent+'</div><column-separator></column-separator><div class="'+ this.columnsFourthContentClasses.value +'">'+this.columnsFourthContent+'</div></div>'
        }
        this.$emit('updateContent',this.index, newContent)
      },
      onSelectionUpdate: ({ editor}) => {
        /*const { view, state } = editor
        const { from, to } = view.state.selection
        const text = state.doc.textBetween(from, to, '')*/
        this.$emit('proceedClick',editor)
        const { view: { state: { tr: { selection } } } } = editor
        this.$emit('proceedMark', !selection.empty)
      },
    })
    
    this.editorColumnsThird = new Editor({
      editorProps: {
        handleClick: () => {
          this.setActiveEditor(this.editorColumnsThird)
        },
        handleDoubleClick: ( ) => {
            this.editorColumnsThird.setEditable(true)
            this.$emit('enableEditMode')
        },
        handleDOMEvents: {
            drop: (view, e) => { e.preventDefault(); },
            paste: (view, e) => {
                if(this.editorColumnsThird.isActive('custom-image') || this.editorColumnsThird.isActive('iframe')){
                    e.preventDefault();
                }
            },
            keydown: (view, e) => {
                /*if ((e.key === "Delete" || e.key === "Enter" || e.key == "Backspace") && (this.editorColumnsThird.isActive('custom-image') || this.editorColumnsThird.isActive('iframe'))) {
                    e.preventDefault();
                }*/
                if(e.key && (this.editorColumnsThird.isActive('custom-image') || this.editorColumnsThird.isActive('iframe'))) {
                    e.preventDefault();
                }
                return false;
            }
        },
        transformPastedHTML: (html) => {
            return html.replace(/<img .*?>/g,'').replace(/<iframe .*?>/g,''); 
        }
      },
      // hide the drop position indicator
      dropCursor: { width: 0, color: 'transparent' },
      extensions: [
        Document,
        Text,
        Bold,
        Italic,
        Underline,
        Strike,
        Highlight,
        CustomLink.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
          },
        }),
        BulletList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        OrderedList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        ListItem,
        Heading.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        CustomParagraph.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        CustomTextStyle,
        Color,
        FontSize,
        Focus.configure({
          className: 'has-focus',
          mode: 'deepest',
        }),
        History,
        HardBreak,
        /*Image.configure({
          inline: false,
        })*/
        CustomImage.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
          //draggable: false
        }),
        Iframe,
        //ExternalVideo,
        CustomDetails.configure({
          persist: true,
          HTMLAttributes: {
            class: 'details-accordion',
          },
        }),
        DetailsSummary.configure({
          HTMLAttributes: {
            class: 'summary-accordion add-transparent-border',
          },
        }),
        CustomDetailsContent.configure({
          HTMLAttributes: {
            class: 'content-accordion add-transparent-border',
          },
        }),
        Placeholder.configure({
          includeChildren: true,
          showOnlyWhenEditable: false,
          placeholder: ({ node }) => {
            if (node.type.name === 'detailsSummary') {
              return i18n.t('accordionTitlePlaceholder')
            }
            return null
          },
        }),
        Emoji.configure({
          enableEmoticons: true,
          suggestion,
          HTMLAttributes: {
            class: 'emoji',
          },
        }),
        CustomTable.configure({
          resizable: true,
          HTMLAttributes: {
            class: 'editor-table',
          }
        }),
        TableRow,
        CustomTableHeader,
        CustomTableCell,
        Gapcursor
        //Div
      ],
      content: this.columnsThirdContent,
      onUpdate: ({ editor}) => {
        this.columnsThirdContent = editor.getHTML()
        var newContent = ''
        if(this.columns == 2){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div></div>'
        }
        if(this.columns == 3){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div><column-separator></column-separator><div class="'+ this.columnsThirdContentClasses.value +'">'+this.columnsThirdContent+'</div></div>'
        }
        if(this.columns == 4){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div><column-separator></column-separator><div class="'+ this.columnsThirdContentClasses.value +'">'+this.columnsThirdContent+'</div><column-separator></column-separator><div class="'+ this.columnsFourthContentClasses.value +'">'+this.columnsFourthContent+'</div></div>'
        }
        this.$emit('updateContent',this.index, newContent)
      },
      onSelectionUpdate: ({ editor}) => {
        /*const { view, state } = editor
        const { from, to } = view.state.selection
        const text = state.doc.textBetween(from, to, '')*/
        this.$emit('proceedClick',editor)
        const { view: { state: { tr: { selection } } } } = editor
        this.$emit('proceedMark', !selection.empty)
      },
    })

    this.editorColumnsFourth = new Editor({
      editorProps: {
        handleClick: () => {
          this.setActiveEditor(this.editorColumnsFourth)
        },
        handleDoubleClick: ( ) => {
            this.editorColumnsFourth.setEditable(true)
            this.$emit('enableEditMode')
        },
        handleDOMEvents: {
            drop: (view, e) => { e.preventDefault(); },
            paste: (view, e) => {
                if(this.editorColumnsFourth.isActive('custom-image') || this.editorColumnsFourth.isActive('iframe')){
                    e.preventDefault();
                }
            },
            keydown: (view, e) => {
                /*if ((e.key === "Delete" || e.key === "Enter" || e.key == "Backspace") && (this.editorColumnsFourth.isActive('custom-image') || this.editorColumnsFourth.isActive('iframe'))) {
                    e.preventDefault();
                }*/
                if (e.key && (this.editorColumnsFourth.isActive('custom-image') || this.editorColumnsFourth.isActive('iframe'))) {
                    e.preventDefault();
                }
                return false;
            }
        },
        transformPastedHTML: (html) => {
            return html.replace(/<img .*?>/g,'').replace(/<iframe .*?>/g,''); 
        }
      },
      // hide the drop position indicator
      dropCursor: { width: 0, color: 'transparent' },
      extensions: [
        Document,
        Text,
        Bold,
        Italic,
        Underline,
        Strike,
        Highlight,
        CustomLink.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
          },
        }),
        BulletList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        OrderedList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        ListItem,
        Heading.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        CustomParagraph.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        CustomTextStyle,
        Color,
        FontSize,
        Focus.configure({
          className: 'has-focus',
          mode: 'deepest',
        }),
        History,
        HardBreak,
        /*Image.configure({
          inline: false,
        })*/
        CustomImage.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
          //draggable: false
        }),
        Iframe,
        //ExternalVideo,
        CustomDetails.configure({
          persist: true,
          HTMLAttributes: {
            class: 'details-accordion',
          },
        }),
        DetailsSummary.configure({
          HTMLAttributes: {
            class: 'summary-accordion add-transparent-border',
          },
        }),
        CustomDetailsContent.configure({
          HTMLAttributes: {
            class: 'content-accordion add-transparent-border',
          },
        }),
        Placeholder.configure({
          includeChildren: true,
          showOnlyWhenEditable: false,
          placeholder: ({ node }) => {
            if (node.type.name === 'detailsSummary') {
              return i18n.t('accordionTitlePlaceholder')
            }
            return null
          },
        }),
        Emoji.configure({
          enableEmoticons: true,
          suggestion,
          HTMLAttributes: {
            class: 'emoji',
          },
        }),
        CustomTable.configure({
          resizable: true,
          HTMLAttributes: {
            class: 'editor-table',
          }
        }),
        TableRow,
        CustomTableHeader,
        CustomTableCell,
        Gapcursor
        //Div
      ],
      content: this.columnsFourthContent,
      onUpdate: ({ editor}) => {
        this.columnsFourthContent = editor.getHTML()
        var newContent = ''
        if(this.columns == 2){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div></div>'
        }
        if(this.columns == 3){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div><column-separator></column-separator><div class="'+ this.columnsThirdContentClasses.value +'">'+this.columnsThirdContent+'</div></div>'
        }
        if(this.columns == 4){
          newContent = '<div class="row content-block" style="background-color: ' + this.background + ';"><div class="'+ this.columnsFirstContentClasses.value +'">'+this.columnsFirstContent+'</div><column-separator></column-separator><div class="'+ this.columnsSecondContentClasses.value +'">'+this.columnsSecondContent+'</div><column-separator></column-separator><div class="'+ this.columnsThirdContentClasses.value +'">'+this.columnsThirdContent+'</div><column-separator></column-separator><div class="'+ this.columnsFourthContentClasses.value +'">'+this.columnsFourthContent+'</div></div>'
        }
        this.$emit('updateContent',this.index, newContent)
      },
      onSelectionUpdate: ({ editor}) => {
        /*const { view, state } = editor
        const { from, to } = view.state.selection
        const text = state.doc.textBetween(from, to, '')*/
        this.$emit('proceedClick',editor)
        const { view: { state: { tr: { selection } } } } = editor
        this.$emit('proceedMark', !selection.empty)
      },
    })
  },

  beforeUnmount() {
    this.editorOneColumn.destroy()
    this.editorColumnsFirst.destroy()
    this.editorColumnsSecond.destroy()
    this.editorColumnsThird.destroy()
    this.editorColumnsFourth.destroy()
  },
   methods: {
    setActiveEditor(editor){
        this.$emit('proceedClick',editor)
    }
  }
}
</script>